export default __webpack_public_path__ + "static/media/confused-face.599d57a0.svg";